<template>
  <div class="home">
    <div
      class=" flex flex-col sticky z-10 shadow bg-white mb-12 w-full"
      style="top: 50px"
    >
      <div class="flex px-8 items-center py-4 mb-4 justify-between">
        <div class="page-heading text-2xl font-semibold">
          Course Instructors
        </div>
      </div>
    </div>
    <div class="px-8 ">
      <div class="mx-4 my-4">
        <div class="mx-8 mt-4">
          <linput
            v-model="search"
            class="py-2"
            placeholder="Search by Instructor Name"
          />
        </div>
      </div>
      <table v-if="filteredRecords.length > 0" class="table-auto w-full">
        <thead>
          <tr class="">
            <th class="px-4 py-1 text-left">S/N</th>
            <th class="w-2/12 px-4 py-1 text-center">Picture</th>
            <th class="w-6/12 px-4 py-1 text-left">Name</th>
            <th class="w-2/12 px-4 py-1 text-left">Email</th>
            <th class="py-2 w-2/12 text-left">Options</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(x, index) in filteredRecords" :key="index">
            <td class="px-4 border-b py-5 text-left">{{ index + 1 }}</td>
            <td class="px-4 py-5 flex justify-center">
              <img
                class="rounded-full object-cover h-8 w-8"
                :src="x.image"
                alt=""
              />
            </td>
            <td class="px-4 border-b py-5 text-left">
              {{ `${x.first_name} ${x.last_name}` }}
            </td>
            <td class="px-4 border-b py-5 text-left">
              {{ `${x.email} ` }}
            </td>
            <td class="px-4 border-b py-5 text-left">
              <a
                style="cursor: pointer"
                @click="
                  $router.push({
                    name: 'tenant-instructor-edit',
                    params: { id: x.id },
                  })
                "
                class="text-green-600"
                >Edit</a
              >
              |
              <a @click="deleteData(x.id)" class="text-red-600" href="#"
                >Delete</a
              >
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text-center text-2xl font-semibold text-black" v-else>
        <empty message="No Instructor Found" />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapMutations } from "vuex";
import Empty from "../../../components/general/Empty";
export default {
  data() {
    return {
      quickSearch: "",
      list: [],
      search: "",
    };
  },
  computed: {
    filteredRecords() {
      let data = this.list.filter((row) => {
        return Object.keys(row).some((key) => {
          return (
            String(row[key])
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) > -1
          );
        });
      });

      return data;
    },
  },
  components: {
    Empty,
    card: () => import("@/components/tenant/reward-card"),
    lbutton: () => import("@/components/general/button"),
    linput: () => import("@/components/general/input"),
  },
  methods: {
    ...mapMutations(["updateLoader"]),
    ...mapActions(["tenantAllInstructors", "tenantDeleteInstructor"]),
    async loadData() {
      this.updateLoader(true);
      let res = await this.tenantAllInstructors();
      this.list = res.data.data.instructors;
      this.updateLoader(false);
    },
    async deleteData(e) {
      if (confirm("Are you sure you want to delete this Instructor?")) {
        let res = await this.tenantDeleteInstructor({
          id: e,
        });
        location.reload();
        this.loadData();
        this.$Bus.$emit("notify", {
          type: "success",
          message: "Instructor deleted successfully",
        });
        //console.log(e);
      }
    },
  },
  async mounted() {
    this.loadData();
  },
};
</script>
